import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useSamplingContext from '../context/useSamplingContext';

function TotalTable() {
  const { totalData, loading } = useContext(useSamplingContext);

  const productColumns = totalData.map((product) => ({
    field: `product_${product.product_id}`,
    headerName: product.product_name,
    minWidth: 100,
    sortable: false,
  }));

  const columns = [{ field: 'metric', headerName: '', minWidth: 200 }, ...productColumns];

  const rows = [
    {
      id: 1,
      metric: 'Product Distributed',
      ...totalData.reduce((acc, product) => {
        acc[`product_${product.product_id}`] = product.product_distribute;
        return acc;
      }, {}),
    },
    {
      id: 2,
      metric: 'Beginning Inventory',
      ...totalData.reduce((acc, product) => {
        acc[`product_${product.product_id}`] = product.beg_balance;
        return acc;
      }, {}),
    },
    {
      id: 3,
      metric: 'Running Balance',
      ...totalData.reduce((acc, product) => {
        acc[`product_${product.product_id}`] = product.running_balance;
        return acc;
      }, {}),
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '250px', marginLeft: '20px' }}>
          &nbsp;
          <DataGridPro
            disableColumnFilter
            rows={rows}
            columns={columns}
            hideFooter
            loading={loading}
            initialState={{
              pinnedColumns: {
                left: ['metric'],
              },
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
}

export default TotalTable;
